<template>
  <div>
    <div class="cs-search-background"></div>
    <div class="cs-search">
      <div class="cs-search-inner">
        <form enctype="multipart/form-data" type="POST" @submit.prevent="fetch">
          <div class="cs-search--field">
            <label class="input-block cs-search--input">
              <span class="input-block--label"></span>
              <input class="cs-search--input" v-model="search" type="text" name="search" placeholder="Search.....">
            </label>
            <button type="submit" class="cs-search--submit">
              <svg class="svg-sprite-icon svg-sprite-unstyled icon-search">
                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-search"></use>
              </svg>
            </button>
            <div class="cs-search--close">
              <svg class="svg-sprite-icon svg-sprite-unstyled icon-close">
                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-close"></use>
              </svg>
            </div>
          </div>
          <div class="cs-search--results">
            <div class="cs-search--list-divider"></div>
            <div class="cs-search--products">
              <template v-for="(product, index) in products">
                <a v-bind:href="'/en/product/' + product.id" class="cs-search--product" v-bind:key="index">
                  <div class="cs-search--product-image">
                    <img :src="'/upload/' + product.image" alt="" >
                  </div>
                  <div class="cs-search--product-favourite">
                    <svg class="svg-sprite-icon svg-sprite-unstyled icon-hearth">
                      <use xlink:href="img/svg/symbol/symbol_unstyled.svg#i-hearth"></use>
                    </svg>
                  </div>
                  <div class="cs-search--product-name">
                    {{product.title}}
                  </div>
                </a>
              </template>
              
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: false
        },
    },
    data: () => ({
        loading: false,
        search: '',
        products: []
    }),
    methods: {
        fetch() {
            this.loading = true;
            if(this.search.length) {
              axios.get(this.url, {
                params: {
                    search: this.search
                }
              }).then((res) => {
                this.products = res.data.data
                this.loading = false;
              });
            }
        },
    },
    mounted() {
        // this.fetch()
    },
}
</script>